export const truncateText = (str: string, maxLength: number) => {
  if (str.length <= maxLength) {
    return str;
  }

  const subString = str.substr(0, maxLength - 1);

  return subString.substr(0, subString.lastIndexOf(' ')) + '…';
};
